import React from 'react';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/style.css';
import ImageGalleryView from './ImageGalleryView';
import { ImageInput } from '@plone/volto/components/manage/Widgets/ImageWidget';
import { useDispatch } from 'react-redux';
import { searchContent } from '@plone/volto/actions/search/search';
import { defineMessages, FormattedMessage } from 'react-intl';

const ImageGalleryEdit = (props) => {
  const dispatch = useDispatch();
  const folderPath = props?.pathname
    ? props.pathname.replace(/\/edit$/, '')
    : props.location?.pathname;
  const messages = defineMessages({
    upload: {
      id: 'upload',
      defaultMessage: 'Select an image to upload and show at the image gallery',
    },
  });
  const handleChange = React.useCallback(async () => {
    dispatch(
      searchContent(
        folderPath,
        {
          'path.depth': 2,
          portal_type: 'Image',
        },
        'images',
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
  return (
    <>
      <h3>
        <FormattedMessage
          id="Image gallery editor view"
          defaultMessage="Image gallery editor view"
        />
      </h3>
      <ImageInput
        onChange={handleChange}
        placeholderLinkInput={'placeholder'}
        block={props.block}
        id={props.block}
        objectBrowserPickerType={'image'}
        hideLinkPicker
        hideObjectBrowserPicker
        description={props.intl.formatMessage(messages.upload)}
      />
      <ImageGalleryView {...props} isEditMode={true} />
    </>
  );
};
export default ImageGalleryEdit;
